import React from "react";
import * as S from "./LoadingScale.styles";
import { ScaleLoader } from "react-spinners";

const LoadingScale = ({ loading }) => {
  return (
    <S.LoadingScale>
      <ScaleLoader
        loading={loading}
        radius={9}
        barCount={5}
        color="#2942ff"
        speedMultiplier={1}
      />
    </S.LoadingScale>
  );
};

export default LoadingScale;
